import React from "react";
import { Link } from "react-router-dom";
import useSEO from "@/hooks/useSEO";

export default function NotFoundPage() {
  useSEO({ title: "Page Not Found", description: "This page doesn't exist. Head back to CardMyDog to create your dog's sports trading card." });
  return (
    <div className="min-h-screen flex items-center justify-center py-16" data-testid="not-found-page">
      <div className="text-center max-w-md mx-auto px-4">
        {/* Dog SVG */}
        <svg className="w-32 h-32 mx-auto mb-6" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="45" fill="var(--color-cream)" stroke="var(--color-border)" strokeWidth="2"/>
          <circle cx="35" cy="22" rx="10" ry="12" fill="var(--color-gold)" opacity="0.6"/>
          <circle cx="65" cy="22" rx="10" ry="12" fill="var(--color-gold)" opacity="0.6"/>
          <circle cx="22" cy="42" rx="8" ry="10" fill="var(--color-gold)" opacity="0.6"/>
          <circle cx="78" cy="42" rx="8" ry="10" fill="var(--color-gold)" opacity="0.6"/>
          <ellipse cx="50" cy="58" rx="18" ry="15" fill="var(--color-gold)" opacity="0.8"/>
          <text x="50" y="85" textAnchor="middle" fill="var(--color-text-mid)" fontSize="10" fontFamily="DM Sans">?</text>
        </svg>

        <h1 className="font-heading text-5xl uppercase tracking-tight text-[var(--color-text-dark)] mb-2">
          4<span style={{ color: "var(--color-gold)" }}>0</span>4
        </h1>
        <h2 className="font-heading text-2xl uppercase tracking-tight text-[var(--color-text-dark)] mb-4">
          Lost in the locker room
        </h2>
        <p className="font-body text-[var(--color-text-mid)] mb-8">
          Looks like this card got lost on the way to the field. Let's get you back in the game.
        </p>
        <Link
          to="/"
          className="inline-block font-heading tracking-widest uppercase px-8 py-3 rounded-[8px] transition-colors"
          style={{ backgroundColor: "var(--color-gold)", color: "var(--color-navy)" }}
          data-testid="back-home-btn"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
